import { render, staticRenderFns } from "./LegalNotice.vue?vue&type=template&id=727c3e01&scoped=true"
import script from "./LegalNotice.vue?vue&type=script&lang=js"
export * from "./LegalNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727c3e01",
  null
  
)

export default component.exports